import { useEffect } from "react";
import { useNavigate } from "@tanstack/react-router";

type UseRedirectIfMatterDeletedParams = {
  matterId: string;
  isDeletedMatter: boolean;
};

export const useRedirectIfMatterDeleted = ({
  matterId,
  isDeletedMatter,
}: UseRedirectIfMatterDeletedParams) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isDeletedMatter) {
      return;
    }

    void navigate({ to: `/matters/${matterId}`, replace: true });
  }, [isDeletedMatter, matterId, navigate]);
};
